import React, { useMemo } from 'react';
import { StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';

import Assets from '../../App/assets';
import { AssetImage } from '../../App/assets/AssetImage';
import locale from '../../App/locale';
import { Colors, Fonts, Sizes } from '../../Common/services/utils/AppConstants';
import { CourseTagType } from '../entities';

type Props = {
  containerStyle?: ViewStyle;
  imageFill?: string;
  textStyle?: TextStyle;
  courseTagType?: CourseTagType;
};

export const CourseTag = (props: Props): React.ReactElement => {
  const text = useMemo(() => {
    if (
      props.courseTagType === CourseTagType.FREETRIAL ||
      props.courseTagType === CourseTagType.FREEACCESS
    ) {
      return locale.common.free_trial;
    }
    return locale.common.purchased;
  }, [props.courseTagType]);

  return (
    <View style={[styles.purchasedContainer, props.containerStyle]}>
      <AssetImage
        asset={Assets.home.purchaseCheck}
        height={10}
        fill={props.imageFill ?? 'white'}
      />
      <Text style={[styles.purchasedText, props.textStyle]}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  purchasedText: {
    ...Fonts.xsmall,
    color: Colors.black50,
  },
  purchasedContainer: {
    backgroundColor: Colors.black06,
    position: 'absolute',
    right: 0,
    paddingHorizontal: Sizes.xsmall,
    paddingVertical: 2,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    borderBottomLeftRadius: Sizes.small,
    borderTopRightRadius: Sizes.small,
  },
});
